/**
 * @file Anything that can run on every page
 */

import * as quicklink from 'quicklink';
import vHeader from '../components/header/header';
import vNavigation from '../components/navigation/navigation';
import vStickyNavigation from '../components/sticky-navigation/sticky-navigation';
import vHpMenu from '../components/hp-menu/hp-menu';
import vHpSlider from '../components/hp-slider/hp-slider';
import vSliderContent from '../components/slider-content/slider-content';
import vDonorStory from '../components/donor-story/donor-story';
import vStoryModal from '../components/story-modal/story-modal';
import vVideoPreview from '../components/video-preview/video-preview';
import vCountdown from '../components/countdown/countdown';
import vEventVideo from '../components/event-video/event-video';
import vDonationCtas from '../components/donation-ctas/donation-ctas';
import vVideoContent from '../components/video-content/video-content';
import vFixedVideo from '../components/fixed-video/fixed-video';
import vAwardBanner from '../components/award-banner/award-banner';
import vProgressBar from '../components/progress-bar/progress-bar';
import vNewsDownloads from '../components/news-downloads/news-downloads';
import vNewsletter from '../components/newsletter/newsletter';

/**
 * Global functions
 *
 * Runs component js and any global tasks
 */
const vGlobal = () => {
	vHeader();
	vNavigation();
	vStickyNavigation();
	vHpMenu();
	vHpSlider();
	vVideoPreview();

	// setTimeout( () => {
	vSliderContent();
	vDonorStory();
	vStoryModal();
	vCountdown();
	vEventVideo();
	vDonationCtas();
	vVideoContent();
	vFixedVideo();
	vProgressBar();
	vAwardBanner();
	vNewsDownloads();
	vNewsletter();
	// }, 1000 );

	const selects = document.querySelectorAll( 'select' );
	[ ...selects ].forEach( ( select ) => {
		const selectParent = select.parentNode;
		if ( selectParent.classList.contains( 'v-form__select' ) ) {
			return;
		}

		const wrapper = document.createElement( 'span' );
		wrapper.classList.add( 'v-form__select' );
		selectParent.insertBefore( wrapper, select );
		wrapper.appendChild( select );

		const arrow = document.createElement( 'span' );
		arrow.classList.add( 'v-form__select-arrow' );
		wrapper.appendChild( arrow );
	} );

	const checkboxes = document.querySelectorAll( '[type="checkbox"]' );
	[ ...checkboxes ].forEach( ( checkbox ) => {
		const checkboxParent = checkbox.parentNode;
		if ( checkboxParent.classList.contains( 'v-form__checkbox-label' ) ) {
			return;
		}

		const box = document.createElement( 'span' );
		box.classList.add( 'v-form__checkbox' );
		checkboxParent.insertBefore( box, checkbox.nextSibling );
		checkbox.classList.add( 'v-form__checkbox-original' );
		checkboxParent.classList.add( 'v-form__checkbox-label' );
	} );

	/**
	 * Global Window Load
	 *
	 * Runs polyfills on page load
	 */
	function onWindowLoad() {
		const body = document.querySelector( 'body' );
		if ( ! body.classList.contains( 'admin-bar' ) ) {
			quicklink.listen( {
				ignores: [
					( url ) => {
						const cleanUrl = url.replace( /#.*/, '' );
						return cleanUrl === window.location.href;
					},
					/.*\/wp-admin\/.*/,
				],
			} );
		}
	}

	if ( document.readyState === 'complete' ) {
		onWindowLoad();
	} else {
		window.addEventListener( 'load', onWindowLoad );
	}
};

if ( document.readyState !== 'loading' ) {
	vGlobal();
} else {
	document.addEventListener( 'DOMContentLoaded', vGlobal );
}
